import React, { Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';

import {
    Typography,
    Box,
    Grid,
    colors,
    Avatar,
    makeStyles
} from '@material-ui/core';
import { Bold } from 'react-feather';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    labelvalue: {
        padding: 12
    },
    labelvaluefail: {
        padding: 12,
        backgroundColor: colors.red[600],
        color: "white",
        borderRadius: 6
    },
    instrumenticonoff: {
        padding: 2,
        width: 45,
        height: 45,
        background: colors.red[500]
    },
    instrumenticonon: {
        padding: 2,
        width: 45,
        height: 45,
        background: colors.green[400]
    },
    instrumenticon: {
        padding: 2,
        width: 45,
        height: 45
    }
}));


const INST02 = ({ instrument, message, event, instruments, alarm, device, schedules, commands, sendCommands }) => {

    const classes = useStyles();

    const isAlarmedField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.id == field._id && fail.type === 'fail') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    return (
        <Fragment>
            <Box padding={1} margin={instrument.border} border={instrument.border} borderRadius={instrument.radius}
                borderColor={colors.grey[300]}>

                <Grid
                    container
                    direction="row"
                    justify="space-evenly"
                    alignItems="center" >

                    <Grid item xs="auto">

                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (

                                    <Avatar className={classes.instrumenticon} variant="square"
                                        src={`/static/images/instruments/` + instrument.simbol}>
                                    </Avatar>

                                ) : (<div></div>)
                            ))
                        ))}

                    </Grid>

                    <Grid item xs="auto">
                        <Grid
                            container
                            direction="column"
                            justify="center"
                            alignItems="center" >

                            <Grid item lg={12}
                                md={12}
                                xs="auto" >

                                <Typography color="textSecondary" variant="h5" className={classes.labelvalue}>
                                    <b>{instrument.label}</b>
                                </Typography>

                            </Grid>

                            <Grid item lg={12}
                                md={12}
                                xs="auto" >

                                {instrument.outputfields.map((infield, index) => (
                                    message.inputs.map((field, index) => (
                                        (field.order === infield.fieldindex) ? (

                                            isAlarmedField(field, alarm) ? (
                                                <Typography color="primary" variant="h5" className={classes.labelvaluefail}  >
                                                    {numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix}
                                                </Typography>

                                            ) : (
                                                <Typography color="primary" variant="h5" className={classes.labelvalue}  >
                                                    {numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix}
                                                </Typography>

                                            )

                                        ) : (<div></div>)
                                    ))
                                ))}

                            </Grid>

                        </Grid>

                    </Grid>

                </Grid>

            </Box>

        </Fragment>
    );

}

export default INST02;